// @owners { team: patients-team }
import { useQuery } from '@tanstack/react-query';
import { queries } from '~shared/queries/query-keys';

export const useQuerySuccessConfigs = () => {
  const { isFetching, isError, isSuccess, data } = useQuery({
    ...queries.onboardingConfigs.fetchOnboardSuccess({ params: {} }),
  });

  const partnershipName = data?.data?.partnership_name;

  return {
    closingImageUrl: data?.data?.closing_image_url,
    closingText: data?.data?.closing_text,
    isFetching,
    isError,
    isSuccess,
    partnershipName,
  };
};
